module.exports = __webpack_public_path__ + "static/media/321-logo-no-tagline-portal.fc176dec.png";